import React from 'react';

import './sliderarrows.scss';

export const NextArrow = function(props) {
    const { className, style, onClick } = props;
    return (
      <i className="fa fa-chevron-right slider_arrow slider_arrow__next" 
        //className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick} >
      </i>
    );
  }
  
export const PrevArrow = function(props) {
    const { className, style, onClick } = props;
    return (
      <i className="fa fa-chevron-left slider_arrow slider_arrow__prev" 
        //className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick} >
      </i>
    );
  }


// WEBPACK FOOTER //
// ./components/shared/SliderArrows.js